import { inject } from '@angular/core';
import { Router, CanActivateFn, CanMatchFn } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import swal from 'sweetalert2';
import { Utf8EncodingService } from './md/service/utf8-encoding.service';

export const canActivateGuard: CanActivateFn = (): Observable<boolean> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const utf8EncodingService = inject(Utf8EncodingService);

  return from(auth.isAuthenticated()).pipe(
    map(isAuth => {
      if (!isAuth) {
        swal.fire('Sorry', 'You are not allowed to access this component.');
        const erpUser = utf8EncodingService.decodeFromUtf8(sessionStorage.getItem('erpUser') as any);
        if (erpUser?.['b_acct_id'] == 0) {
          router.navigate(['./solution-admin/index']);
        } else {
          router.navigate(['./index']);
        }
        return false;
      }
      return true;
    })
  );
};

export const canMatchGuard: CanMatchFn = (): Observable<boolean> => {
  const router = inject(Router);

  // canMatch only guards lazy-module downloading — just check the user has a session.
  // Do NOT use isAuthenticated() here: that checks mainService.componentCode which is
  // only set by RoleGuardService.canActivate() (runs after canMatch), so it would
  // always be undefined on first navigation and block the module from loading.
  if (!sessionStorage.getItem('1001') || !sessionStorage.getItem('1000')) {
    router.navigate(['/login']);
    return of(false);
  }
  return of(true);
};
